import actions from './actions'
import reducer from './reducer'

export default {
  name: 'UiSelection',
  actions,
  reducer,
}